module.exports = __webpack_public_path__ + "img/Plastic006_1K_Displacement.d85479a9.jpg";